import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

const PARAM = 'create'

/** 绑定 URL ?create=<kind> ↔ 全局创建中心当前打开项。镜像 useDeepLinkFlyout 的参数保留逻辑。 */
export function useCreateFlyoutDeepLink() {
  const [searchParams, setSearchParams] = useSearchParams()
  const activeKind = searchParams.get(PARAM)

  const open = useCallback((kind: string) => {
    const next = new URLSearchParams(searchParams)
    next.set(PARAM, kind)
    setSearchParams(next, { replace: false })
  }, [searchParams, setSearchParams])

  const close = useCallback(() => {
    const next = new URLSearchParams(searchParams)
    next.delete(PARAM)
    setSearchParams(next, { replace: true })
  }, [searchParams, setSearchParams])

  return { activeKind, open, close }
}
